import React, { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Benefits from "@/components/landing/Benefits";
import OfferStack from "@/components/landing/OfferStack";
import MealCategories from "@/components/landing/MealCategories";
import AgeTimeline from "@/components/landing/AgeTimeline";
import MockupGallery from "@/components/landing/MockupGallery";
import MidCTA from "@/components/landing/MidCTA";
import Guarantees from "@/components/landing/Guarantees";
import Testimonials from "@/components/landing/Testimonials";
import Bonuses from "@/components/landing/Bonuses";
import FinalCTA from "@/components/landing/FinalCTA";
import Guarantee from "@/components/landing/Guarantee";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import WhatsAppFloating from "@/components/landing/WhatsAppFloating";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import { trackViewContent } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    // Fire ViewContent once the user actually sees the product landing page.
    trackViewContent();
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#F4EBDE] text-[#2A302A] pb-20 lg:pb-0">
      <Navbar />
      <Hero />
      <Benefits />
      <OfferStack />
      <MealCategories />
      <AgeTimeline />
      <MockupGallery />
      <Guarantees />
      <MidCTA />
      <Testimonials />
      <Bonuses />
      <FinalCTA />
      <Guarantee />
      <FAQ />
      <Footer />
      <WhatsAppFloating />
      <StickyMobileCTA />
    </div>
  );
}
